import { CategoryPage } from '@stuller/stullercom/feat/category-page'

export default CategoryPage
